import React from 'react';
import PropTypes from 'prop-types';

const colorMap = ['danger','warning','success','primary'];
const labelMap = ['Pass','Consider','Recommend','Highly Recommend'];
const symbol   = ['❌','⚠️','👍','✅'];

export default function Badge ({ rating, prefix }) {
  if (rating == null) return null;
  const idx = Math.max(0, Math.min(3, rating));
  return (
    <span className={`badge bg-${colorMap[idx]} me-1`}>
      {prefix && <span className="me-1">{prefix}</span>}{labelMap[idx]} {symbol[idx]}
    </span>
  );
}
Badge.propTypes = { rating: PropTypes.number, prefix: PropTypes.string };